<template>
  <div class="promo-images">
    <a   class="promo-images__item">
      <img src="@/images/top.gif" alt="top" />
    </a>
    <a   class="promo-images__item">
      <img src="@/images/ydt.png" alt="ydt" />
    </a>
    <a  class="promo-images__item">
      <img src="@/images/chrome.gif" alt="chrome" />
    </a>
  <a   class="promo-images__item">
    <img src="@/images/rich.gif" alt="rich" />
  </a>
  <a   class="promo-images__item">
    <img src="@/images/gs.jpg" alt="rich" />
  </a>
  <a  class="promo-images__item">
    <img src="@/images/xdddd.gif" alt="rich" />
  </a>
  <a   class="promo-images__item">
    <img src="@/images/xdddd.gif" alt="rich" />
  </a>
  <a   class="promo-images__item">
    <img src="@/images/touf.jpg" alt="rich" />
  </a>
  </div>
</template>

<script>
export default { name: 'PromoImages' }
</script>

<style scoped>
.promo-images {
  display: flex; flex-direction: column; gap: clamp(0.4rem, 2vw, 0.6rem);
  padding: 0;
  width: 100%;
}
.promo-images__item {
  display: block; width: 100%;
}
.promo-images__item img {
  width: 100%; height: auto; display: block;
  /* border-radius: clamp(0.35rem, 1.5vw, 0.5rem); */
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
</style>
